import React from 'react';
import { Box, ContentTemplate, Progress, TextFieldForm } from 'web-library';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import { UseFormReturn } from 'react-hook-form';
import { CoordinatorProfileResponseObject } from 'web-library/models/AccountManagementConfiguration';
import { ContactNumberFormItem } from '../../../components/form-items/ContactNumberFormItem';
import ToggleDisplayEditFormItem from '../../../components/ToggleDisplayEditFormItem';
import { getContactDisplayValue } from '../../../utils/ComponentUtils';
import { useGetIExamMasterCode } from '../../../api-refactored/user/useGetIExamMasterCode';
import { IExamMasterCodeItem } from '../../../api/user/model';
import {
  CoordinatorProfileResponseIsDisableInputs,
  CreateEditCoordinatorSchemaData,
} from './CreateEditCoordinatorSchema';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  halfWidthLeftItem: {
    width: '50%',
    paddingRight: theme.spacing(2),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  halfWidthRightItem: {
    width: '50%',
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
      marginBottom: theme.spacing(2),
    },
  },
  responsiveFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  formElementContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
    width: '100%',
  },
  keyValueContainer: {
    marginBottom: 0,
  },
}));

export interface CoordinatorContactInformationProps {
  coordinatorProfileDetails?: CoordinatorProfileResponseObject;
  formHook?: UseFormReturn<CreateEditCoordinatorSchemaData>;
  isEditState: boolean;
  disabledFields?: CoordinatorProfileResponseIsDisableInputs;
}

const CoordinatorContactInformation = ({
  coordinatorProfileDetails,
  formHook,
  isEditState,
  disabledFields,
}: CoordinatorContactInformationProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const { data: iExamMasterCode } = useGetIExamMasterCode();

  const mobileNumberCountryCodeDefaultObject =
    iExamMasterCode &&
    iExamMasterCode.countryCode.find(
      (obj: IExamMasterCodeItem) =>
        obj.codeValue === coordinatorProfileDetails?.contactNumber.countryCode.codeValue.toString()
    );

  if (
    coordinatorProfileDetails?.contactNumber &&
    mobileNumberCountryCodeDefaultObject === undefined
  ) {
    return (
      <ContentTemplate>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <Box className={classes.responsiveFlexContainer}>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        containerClassName={classes.formElementContainer}
        labelText={t('admin->>UserAccountManagement.EmailAddress')}
        id="inputText-candidateProfile-email"
        valueText={coordinatorProfileDetails?.email}
        EditComponent={
          formHook && (
            <TextFieldForm
              form={formHook}
              id="inputText-candidateProfile-email"
              label={t('admin->>UserAccountManagement.EmailAddress')}
              placeholder="Enter email address"
              isSubLabelBelowLabel
              defaultValue={coordinatorProfileDetails?.email}
              name="email"
              type="text"
              error={!!formHook.formState.errors.email}
              helperText={formHook.formState.errors?.email?.message?.toString()}
              fullWidth
              isRequired
            />
          )
        }
      />
      <ToggleDisplayEditFormItem
        id="mobileNo"
        isEditState={isEditState}
        labelText={t('admin->>UserAccountManagement.MobileNo')}
        valueText={getContactDisplayValue(
          false,

          coordinatorProfileDetails?.contactNumber.countryCode.codeValueDescription,
          coordinatorProfileDetails?.contactNumber.number
        )}
        containerClassName={classes.formElementContainer}
        EditComponent={
          formHook && (
            <ContactNumberFormItem
              id="candidateProfileMobile"
              formHook={formHook}
              label={t('admin->>UserAccountManagement.MobileNo')}
              placeholder="Enter mobile no."
              countryCode={{
                name: 'mobileCountryCode',
                error: !!formHook.formState.errors.mobileCountryCode,
                helperText: formHook.formState.errors?.mobileCountryCode?.message?.toString(),
                disabled: disabledFields?.mobileCountryCode,
              }}
              countryCodeisOptionEqualToValue={(option, value) => option.codeId === value.codeId}
              number={{
                name: 'mobileContactNumber',
                error: !!formHook.formState.errors.mobileContactNumber,
                helperText: formHook.formState.errors?.mobileContactNumber?.message?.toString(),
                disabled: disabledFields?.mobileContactNumber,
              }}
              isSkipTransform
              countryCodeDefaultValue={mobileNumberCountryCodeDefaultObject}
              numberDefaultValue={coordinatorProfileDetails?.contactNumber.number}
              isRequired
            />
          )
        }
      />
    </Box>
  );
};
export default CoordinatorContactInformation;
